export default "__VITE_ASSET__BnmQOIob__"